import AlertAmount from "./AlertAmount";

export default AlertAmount;
